// extracted by mini-css-extract-plugin
export default {"growWrap":"UserInput_growWrap__d03uh","textinput":"UserInput_textinput__Af7Fj"};